import { defineComponent as _defineComponent } from 'vue'


interface Props {
    message: string;
    closable?: boolean;
    type?: 'error' | 'warning' | 'info' | 'success';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserNotification',
  props: {
    message: { type: String, required: true },
    closable: { type: Boolean, required: false },
    type: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const incoming = __props;
const closable = incoming.closable ?? true; 

const __returned__ = { incoming, closable }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})